import { CUSTOMER_SERVICE_URL } from '@/app-constants/env.constant';
import {
  fetchSSEWithAuthorizationAndPersonation,
  fetchJsonWithAuthorizationAndPersonation,
  SSEChunk,
} from '@/utils/fetch.utils';

const ROOT_URL = `${CUSTOMER_SERVICE_URL}/api`;

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatRequest {
  message: string;
  messages?: ChatMessage[];
  systemPrompt?: string;
  tenantIds?: string[];
  managedTenantId?: string;
}

export interface ChatResponse {
  response: string;
  model_id?: string;
}

export async function* streamChat(request: ChatRequest, chatId: string): AsyncGenerator<SSEChunk> {
  const url = `${ROOT_URL}/chat/stream`;

  const body = JSON.stringify({
    message: request.message,
    messages: request.messages,
    system_prompt: request.systemPrompt,
    tenant_ids: request.tenantIds,
    managed_tenant_id: request.managedTenantId,
  });

  const headers: Record<string, string> = {
    'X-Chat-Id': chatId,
  };

  yield* fetchSSEWithAuthorizationAndPersonation(
    url,
    {
      method: 'POST',
      body,
    },
    headers,
  );
}

export const sendChatMessage = async (request: ChatRequest): Promise<ChatResponse> => {
  const url = `${ROOT_URL}/chat`;

  return fetchJsonWithAuthorizationAndPersonation<ChatResponse>(url, {
    method: 'POST',
    body: JSON.stringify({
      message: request.message,
      messages: request.messages,
      system_prompt: request.systemPrompt,
      tenant_ids: request.tenantIds,
      managed_tenant_id: request.managedTenantId,
    }),
  });
};
